//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { BreadcrumbItemToggleMessage } from '@shared/components/breadcrumb/messages/breadcrumb-item-toggle.message';
import { IBreadcrumbItemModel } from '@shared/components/breadcrumb/models/breadcrumb-item.model';
import { Messenger } from '@shared/data/messaging/messenger';
import { NodeModel } from '@shared/data/models/node.model';
import { PresenterType } from '@shared/components/presenter/presenter-type';

@PresenterType(
{
    model: NodeModel<IBreadcrumbItemModel>
})
@Component({
    selector: 'filter-item-template',
    templateUrl: './filter-item-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FilterItemTemplateComponent
{
    public data: WritableSignal<NodeModel<IBreadcrumbItemModel>>;

    constructor(private messenger: Messenger) {
        this.data = signal<NodeModel<IBreadcrumbItemModel>>(null);
    }

    public toggleBreadcrumb(obj: IBreadcrumbItemModel) {
        this.messenger.send(new BreadcrumbItemToggleMessage(obj));
    }
}